import { coalColor } from "../../../styles/theme";
import { IconProps } from "./";

export const CloseIcon = ({ size = 24, color = coalColor }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8C12.9067 11.6267 20 18 24 24"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8 24C12.8889 19.5556 14.6667 13.3333 24 8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
